/* eslint-disable react/prop-types */
import React, { FunctionComponent, ChangeEvent } from "react";
import PropTypes from "prop-types";
import Theme from "../../../theme/theme";
import { StyledLabel, StyledInput, StyledCheck } from "./styles";

export interface RadioButtonProps {
  name: string;
  label: string;
  value: string;
  disabled?: boolean;
  checked?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const RadioButton: FunctionComponent<RadioButtonProps> = ({
  name,
  label,
  value,
  disabled,
  checked,
  onChange,
}) => (
  <Theme>
    <StyledLabel disabled={disabled}>
      <StyledInput
        data-testid="radio-button"
        type="radio"
        aria-label={label}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      {label}
      <StyledCheck disabled={disabled} />
    </StyledLabel>
  </Theme>
);

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
};

RadioButton.defaultProps = {
  disabled: null,
  checked: null,
};

export default RadioButton;
